exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check[data-v-106ae805]{margin-bottom:10px}.card[data-v-106ae805]{border-radius:10px;box-shadow:0 2px 10px rgba(0,0,0,.1)}.btn-lg[data-v-106ae805]{padding:12px 30px;font-size:16px}", ""]);

// exports
